<template>
  <fund-test-accounts
    :is-loading="isLoading"
    :funded-accounts="fundedAccounts"
    :project-name-by-id="projectNameById"
    :currencies="currencies"
    @fund="onFundTestAccounts"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import { API } from '@/utils/api'
import FundTestAccounts from '../components/FundTestAccounts.vue'

export default {
  components: {
    FundTestAccounts,
  },

  data() {
    return {
      isLoading: false,
      fundedAccounts: [],
    }
  },

  computed: {
    currencies() {
      return this.$store.state.auth.currencies
    },
    ...mapGetters('auth', [ 'projectNameById' ]),
  },

  mounted() {},

  methods: {
    onFundTestAccounts(args) {
      this.isLoading = true
      return API.call('/$v/tools/fund_test_accounts.json', args)
        .then(r => {
          this.fundedAccounts = r.data
          this.$showSuccess('Updated successfully')
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  },
}
</script>
